import { faCirclePlus, faEye, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CenterService from '../../services/center.service';
import InputBox from '../Input/InputBox';
import XcnButton from '../XcnButton/XcnButton';
import XcnModal from './XcnModal';
import AddFloorLab from './FloorLabs.modal';

interface IViewBuildingPlan {
    showViewBuildingPlan: any
    setShowViewBuildingPlan: any,
    buildingId: string,
    centerId: string
    floorData: any
}

export default function ViewFloorModal({
    showViewBuildingPlan,
    setShowViewBuildingPlan,
    buildingId,
    centerId,
    floorData,
}: IViewBuildingPlan) {


    const [building, setBuilding] = useState<any>();

    const [selectedFloor, setSelectedFloor] = useState<any>(undefined);
    const [showLabImageModal, setShowLabImageModal] = useState<boolean>(false)


    const getFloors = async () => {
        await CenterService.getFloors(buildingId).then(res => {
            if (res.status === 200) {
                setBuilding(res.data);
            }
        })
    }


    useEffect(() => {
        getFloors();
    }, [showViewBuildingPlan, selectedFloor])


    const deleteFloor = async (floorId: string) => {
        await CenterService.removeFloorFromBuilding(buildingId, floorId).then(res => {
            if (res.status === 200) {
                toast.warning("Floor Removed")
                setShowViewBuildingPlan(false)
            }
        })
    }


    const onLabSave = async (floorId: string, labdata: { name: string, computerCount: string, dvrCount: number, cameraCount: number, labImage: string }) => {
        await CenterService.addFloorLab(buildingId, floorId, labdata).then(res => {
            if (res.status === 200) {
                toast.success("Lab Added")
                setSelectedFloor(false)
            }
        })
    }

    const deleteLab = async (floorId: string, labId: string) => {
        await CenterService.removeLabFromFloor(buildingId, floorId, labId).then(res => {
            if (res.status === 200) {
                toast.warning("Lab Removed")
                getFloors()
            }
        }).catch((e: any) => {
            toast.error(e.response.data.message)
            console.error(e)
        })
    }


    return (
        <>
            <AddFloorLab
                floorId={selectedFloor}
                onSave={(floorId: any, labdata: { name: string, computerCount: string, dvrCount: number, cameraCount: number, labImage: string }) => onLabSave(floorId, labdata)}
                onClose={() => setSelectedFloor(undefined)}

            />



            <XcnModal
                size="lg"
                show={showViewBuildingPlan}
                handleClose={() => setShowViewBuildingPlan(false)}
                body={
                    <>
                        {building && building.floors && building.floors.length > 0 ? building.floors.map((data: any, index: number) => {
                            return (
                                <Card className='xcn-card border border-1 border-muted mt-3 rounded'>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>
                                                <span className="fw-bold">Floor Name: </span>
                                                <span>{data.name}</span>
                                            </span>
                                            <span>
                                                <span className="fw-bold">Floor Number: </span>
                                                <span>{data.number}</span>
                                            </span>
                                        </div>
                                        <div className='d-flex justify-content-end align-items-center mt-2'>
                                            <XcnButton
                                                text="Add Lab"
                                                onClick={() => setSelectedFloor(data._id)}
                                                size="sm"

                                            />
                                            <XcnButton
                                                text="Delete Floor"
                                                onClick={() => deleteFloor(data._id)}
                                                size="sm"
                                                className="ms-3"
                                                variant='danger'
                                            />
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <h6 className='fw-bold text-primary'>
                                                Labs ({data.labs && data.labs.length})
                                            </h6>
                                            <h6 className='fw-bold text-primary'>
                                                System Count({data.labs && data.labs.length > 0 ? data.labs.reduce((a: any, b: any) => a + b.computerCount, 0) : 0})

                                            </h6>
                                        </div>
                                        <div className='bg-light mt-2 rounded p-2'>

                                            {data.labs && data.labs.length > 0 && data.labs.map((lab: any, index: number) => {
                                                return (
                                                    <div className='my-3'>
                                                        <div className='d-flex justify-content-end align-items-center'>
                                                            <div>
                                                                <Button variant="secondary" className="me-2" size="sm">
                                                                    <FontAwesomeIcon icon={faEye} className='me-2' />
                                                                    <a href={lab && lab.labImage} className="text-decoration-none text-white" download={true}>
                                                                        Download Lab Image
                                                                    </a>
                                                                </Button>
                                                                <Button variant="danger" onClick={() => deleteLab(data._id, lab._id)} size="sm">
                                                                    <FontAwesomeIcon icon={faTimesCircle} className='me-2' />
                                                                    Delete Lab
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <span>
                                                                <span className="fw-bold">Name: </span>
                                                                <span>{lab.name}</span>
                                                            </span>
                                                            <span>
                                                                <span className="fw-bold">Computer Count: </span>
                                                                <span>{lab.computerCount}</span>
                                                            </span>

                                                        </div>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <span>
                                                                <span className="fw-bold">DVR Count: </span>
                                                                <span>{lab.dvrCount}</span>
                                                            </span>
                                                            <span>
                                                                <span className="fw-bold">Camera Count: </span>
                                                                <span>{lab.cameraCount}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            }

                                        </div>

                                    </Card.Body>
                                </Card>
                            )
                        }) : "No Floors Available"}
                    </>
                }
                heading="View Floors"
            />
        </>
    )
}